module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/child-chair-desk/chairDesk.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/child-chair-desk/chairDesk.png
// module id = 536
// module chunks = 0